import {
    AutoComplete,
    DatePicker,
    Input,
    Modal,
    Table,
    TableColumnsType,
    notification,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { crossIcon, dangerIcon, dueIcon, resetIcon, tickIcon2 } from './common/Icons';
import {
    Dose,
    DoseInfo,
    IVaccineStatus,
    I_VACCINATION_STATUS,
    VACCINATION_STATUS,
    diseaseIdToName,
} from '../api/fetchVaccineSchedule';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { updateAdministeredVaccines, updateFollowup } from '../store/actions/prescriptionPad';
import { AntTooltip } from './common/AntTooltip';
import AntSelect from './prescriptionPad/rightPanel/workspace/padV2/AntSelect';
import { generateLocalId } from '../store/utils';
import { track } from '../tracking';
import { getPrescription } from '../store/selectors/prescriptionPad';

export type Status =
    | VACCINATION_STATUS.GIVEN
    | VACCINATION_STATUS.DUE
    | VACCINATION_STATUS.MISSED
    | VACCINATION_STATUS.PATIENT_REFUSED;

export const buttons = [
    {
        text: VACCINATION_STATUS.GIVEN,
        type: 'button',
        icon: (
            <span className="border border-darwin-green-primary flex items-center justify-center rounded-full">
                {tickIcon2('fill-darwin-green-primary font-700 w-12 h-12')}
            </span>
        ),
        icon2: (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375ZM7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM9.86914 5.93164L6.61914 9.18164C6.36523 9.43555 5.98438 9.43555 5.75586 9.18164L4.13086 7.55664C3.87695 7.32812 3.87695 6.94727 4.13086 6.71875C4.35938 6.46484 4.74023 6.46484 4.99414 6.71875L6.1875 7.91211L9.00586 5.09375C9.23438 4.83984 9.61523 4.83984 9.86914 5.09375C10.0977 5.32227 10.0977 5.70312 9.86914 5.93164Z"
                    fill="#215FFF"
                />
            </svg>
        ),
    },
    {
        text: VACCINATION_STATUS.DUE,
        type: 'button',
        icon: dueIcon('w-14 h-14'),
        icon2: (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.2812 7.125C12.2812 5.24609 11.2656 3.51953 9.64062 2.55469C7.99023 1.61523 5.98438 1.61523 4.35938 2.55469C2.70898 3.51953 1.71875 5.24609 1.71875 7.125C1.71875 9.0293 2.70898 10.7559 4.35938 11.7207C5.98438 12.6602 7.99023 12.6602 9.64062 11.7207C11.2656 10.7559 12.2812 9.0293 12.2812 7.125ZM0.5 7.125C0.5 4.81445 1.71875 2.68164 3.75 1.51367C5.75586 0.345703 8.21875 0.345703 10.25 1.51367C12.2559 2.68164 13.5 4.81445 13.5 7.125C13.5 9.46094 12.2559 11.5938 10.25 12.7617C8.21875 13.9297 5.75586 13.9297 3.75 12.7617C1.71875 11.5938 0.5 9.46094 0.5 7.125ZM6.39062 3.67188C6.39062 3.3418 6.64453 3.0625 7 3.0625C7.33008 3.0625 7.60938 3.3418 7.60938 3.67188V6.82031L9.76758 8.24219C10.0469 8.44531 10.123 8.82617 9.94531 9.10547C9.74219 9.38477 9.36133 9.46094 9.08203 9.25781L6.64453 7.63281C6.49219 7.53125 6.39062 7.32812 6.39062 7.125V3.67188Z"
                    fill="#215FFF"
                />
            </svg>
        ),
    },
    {
        text: VACCINATION_STATUS.PATIENT_REFUSED,
        type: 'button',
        icon: (
            <span className="bg-red-primary p-3 flex items-center justify-center rounded-full">
                {crossIcon('fill-white font-700 w-8 h-8')}
            </span>
        ),
        icon2: (
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375ZM7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM4.94336 5.06836C5.17188 4.83984 5.55273 4.83984 5.78125 5.06836L6.97461 6.26172L8.16797 5.06836C8.42188 4.83984 8.80273 4.83984 9.03125 5.06836C9.28516 5.32227 9.28516 5.70312 9.03125 5.93164L7.83789 7.125L9.03125 8.31836C9.28516 8.57227 9.28516 8.95312 9.03125 9.18164C8.80273 9.43555 8.42188 9.43555 8.16797 9.18164L6.97461 7.98828L5.78125 9.18164C5.55273 9.43555 5.17188 9.43555 4.94336 9.18164C4.68945 8.95312 4.68945 8.57227 4.94336 8.31836L6.13672 7.125L4.94336 5.93164C4.68945 5.70312 4.68945 5.32227 4.94336 5.06836Z"
                    fill="#215FFF"
                />
            </svg>
        ),
    },
    {
        text: VACCINATION_STATUS.MISSED,
        type: 'button',
        icon: (
            <span className="flex items-center justify-center rounded-full">
                {dangerIcon('w-14 h-14')}
            </span>
        ),
        icon2: (
            <svg
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.79688 1.7832L1.76953 10.0352C1.71875 10.1113 1.71875 10.1621 1.71875 10.2383C1.71875 10.4414 1.87109 10.5938 2.07422 10.5938H11.9004C12.1035 10.5938 12.2812 10.4414 12.2812 10.2383C12.2812 10.1621 12.2559 10.1113 12.2051 10.0352L7.17773 1.7832C7.15234 1.70703 7.07617 1.65625 7 1.65625C6.89844 1.65625 6.84766 1.70703 6.79688 1.7832ZM5.75586 1.14844C6.00977 0.716797 6.49219 0.4375 7 0.4375C7.48242 0.4375 7.96484 0.716797 8.21875 1.14844L13.2461 9.40039C13.3984 9.6543 13.5 9.93359 13.5 10.2383C13.5 11.1016 12.7891 11.8125 11.9004 11.8125H2.07422C1.21094 11.8125 0.5 11.1016 0.5 10.2383C0.5 9.93359 0.576172 9.6543 0.728516 9.40039L5.75586 1.14844ZM7.8125 8.96875C7.8125 9.42578 7.43164 9.78125 7 9.78125C6.54297 9.78125 6.1875 9.42578 6.1875 8.96875C6.1875 8.53711 6.54297 8.15625 7 8.15625C7.43164 8.15625 7.8125 8.53711 7.8125 8.96875ZM7.60938 4.29688V6.73438C7.60938 7.08984 7.33008 7.34375 7 7.34375C6.64453 7.34375 6.39062 7.08984 6.39062 6.73438V4.29688C6.39062 3.9668 6.64453 3.6875 7 3.6875C7.33008 3.6875 7.60938 3.9668 7.60938 4.29688Z"
                    fill="#215FFF"
                />
            </svg>
        ),
    },
    {
        text: 'Reset',
        type: 'button',
        icon2: crossIcon('fill-white font-700 w-14 h-12'),
        hideText: true,
    },
];

const column: TableColumnsType<any> = [
    {
        title: <p className="text-13 text-darwin-neutral-800 capitalize font-700">Vaccine</p>,
        dataIndex: 'vaccine',
        key: 'vaccine',
        fixed: 'left',
    },
    {
        title: <p className="text-13 text-darwin-neutral-800 capitalize font-700">Status</p>,
        dataIndex: 'status',
        key: 'status',
        width: '15%',
    },
    {
        title: <p className="text-13 text-darwin-neutral-800 capitalize font-700">Date</p>,
        dataIndex: 'administeredDate',
        key: 'administeredDate',
        width: '15%',
    },
    {
        title: <p className="text-13 text-darwin-neutral-800 capitalize font-700">Brand</p>,
        dataIndex: 'brand',
        key: 'brand',
        width: '20%',
    },
    {
        title: <p className="text-13 text-darwin-neutral-800 capitalize font-700">Batch Number</p>,
        dataIndex: 'batchNo',
        key: 'batchNo',
        width: '15%',
    },
    {
        title: (
            <p className="text-13 text-darwin-neutral-800 capitalize font-700">Notes (if any)</p>
        ),
        dataIndex: 'notes',
        key: 'notes',
        width: '15%',
    },
    {
        title: '',
        dataIndex: 'delete',
        key: 'delete',
        width: '4%',
    },
];

const VaccineSelectionModal: React.FC<{
    isVisible?: boolean;
    closeModal: () => void;
    selectedVaccines: Dose[] | undefined;
    setSelectedVaccines: (val: Dose[] | undefined) => void;
    setAdministedVaccines: (val: IVaccineStatus[]) => void;
    initialStatus: IVaccineStatus[];
    vaccineData:
        | {
              [diseaseId: string]: {
                  vaccineSchedule: DoseInfo;
                  dateRange: {
                      minDaysFromBirth: string;
                      maxDaysFromBirth?: string | undefined;
                  };
              };
          }
        | undefined;
    administeredVaccines: IVaccineStatus[];
    dob: moment.Moment;
    clearCheckedAgeGroups: () => void;
    currPlan: any;
    title: string | undefined;
    isBlockStatus?: boolean | undefined;
    onChange?: (newVaccs: IVaccineStatus[], allVaccs: IVaccineStatus[]) => void;
    onDueFollowupSet?: (item: IVaccineStatus) => void;
}> = ({
    isVisible = false,
    closeModal,
    selectedVaccines,
    setSelectedVaccines,
    setAdministedVaccines,
    initialStatus,
    vaccineData,
    administeredVaccines,
    dob,
    clearCheckedAgeGroups,
    currPlan,
    title,
    isBlockStatus,
    onChange,
    onDueFollowupSet,
}) => {
    const [vaccineStatus, setVaccineStatus] = useState<IVaccineStatus[]>([]);
    const dispatch = useDispatch();

    const px = useSelector(getPrescription);

    useEffect(() => {
        setVaccineStatus(initialStatus);
    }, [isVisible]);

    const setVaccine = (vid: string, payload: Partial<IVaccineStatus>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setVaccineStatus((prev) => {
            const currVac = prev?.find((val) => val.id === vid);
            return [...prev.filter((p) => p.id !== vid), { ...currVac, ...payload }];
        });
    };

    const today = moment();

    const disabledDateDue = (current: moment.Moment | undefined, date: moment.Moment) => {
        return current && (current < dob.endOf('day') || current < date.endOf('day'));
    };

    const disabledDateGiven = (current: moment.Moment | undefined, date: moment.Moment) => {
        return current && (current < dob.endOf('day') || current > date.endOf('day'));
    };

    const getDefaultDate = (administeredVaccines: IVaccineStatus[], date?: string, id?: string) => {
        const defaultDates = administeredVaccines?.map((vac) => {
            return {
                id: vac.id,
                date: vac.date,
            };
        });

        const isAdministered = defaultDates.find((v) => v.id === id);

        return isAdministered?.date ? moment(isAdministered.date) : date ? moment(date) : undefined;
    };

    const finalSelectedVaccines =
        isBlockStatus && selectedVaccines
            ? selectedVaccines.filter(
                  (val) =>
                      val.status?.status !== VACCINATION_STATUS.GIVEN &&
                      val.status?.status !== VACCINATION_STATUS.MISSED &&
                      val.status?.status !== VACCINATION_STATUS.PATIENT_REFUSED,
              )
            : selectedVaccines;

    const data = finalSelectedVaccines
        ? finalSelectedVaccines.map((v, idx) => {
              const currStatus = vaccineStatus.find((val) => val.id === v.vaccineId);

              const defaultDate = getDefaultDate(
                  administeredVaccines,
                  currStatus?.date,
                  currStatus?.id,
              );

              return {
                  key: idx + 1,
                  vaccine: <p className="text-13 font-700">{currStatus?.name}</p>,
                  status: (
                      <AntSelect
                          options={buttons
                              .filter((b) => b.text !== 'Reset')
                              .map((val) => {
                                  return {
                                      value: (
                                          <span className="flex w-full h-full items-center gap-8">
                                              {val.icon}
                                              <p className="text-14">{val.text}</p>
                                          </span>
                                      ),
                                      id: val.text,
                                  };
                              })}
                          getValue={(o) => o.id}
                          getLabelToCompare={(o) => o.value}
                          placeholder="Select Status"
                          className="w-full rounded-4"
                          setValue={(option) => {
                              setVaccine(v.vaccineId, {
                                  status: option?.id as I_VACCINATION_STATUS,
                              });
                          }}
                          showSearch
                          allowClear
                          value={
                              currStatus?.status
                                  ? {
                                        id: currStatus.status,
                                        value: (
                                            <span className="flex h-full w-full items-center gap-8">
                                                {
                                                    buttons.find(
                                                        (b) => b.text === currStatus.status,
                                                    )?.icon
                                                }
                                                <p className="text-14">{currStatus.status}</p>
                                            </span>
                                        ),
                                    }
                                  : undefined
                          }
                          disabled={!!isBlockStatus}
                      />
                  ),
                  administeredDate: (
                      <div className={`flex copy-date-${idx} flex-col`}>
                          <DatePicker
                              className="w-full h-full rounded-4"
                              defaultValue={defaultDate}
                              defaultPickerValue={defaultDate}
                              format="DD MMM'YY"
                              placeholder="Select date"
                              onChange={(value) => {
                                  setVaccine(v.vaccineId, { date: value?.toISOString() });
                              }}
                              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                              // @ts-ignore
                              disabledDate={
                                  currStatus?.status === VACCINATION_STATUS.DUE
                                      ? (current) => disabledDateDue(current, today)
                                      : (current) => disabledDateGiven(current, today)
                              }
                              value={currStatus?.date ? moment(currStatus.date) : null}
                          />
                          <AntTooltip placement="bottom" content="Copy to all">
                              <div
                                  className={`rounded-full cursor-pointer copy-child-element-${idx} absolute p-2 right-12 bottom-12 bg-darwin-neutral_new-800`}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      const currDate = currStatus?.date;

                                      finalSelectedVaccines.forEach((vac) => {
                                          const currVac = vaccineStatus.find(
                                              (v) => v.id === vac.vaccineId,
                                          );

                                          if (currVac?.status === currStatus?.status) {
                                              setVaccine(vac.vaccineId, { date: currDate });
                                          }
                                      });
                                  }}
                              >
                                  <svg
                                      className="copy fill-white m-2 w-8 h-8"
                                      role="img"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 512 512"
                                  >
                                      <path d="M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"></path>
                                  </svg>
                              </div>
                          </AntTooltip>
                          <style>
                              {`
                                .copy-child-element-${idx} {
                                    display: none;
                                }

                                .copy-date-${idx}:hover .copy-child-element-${idx} {
                                    display: flex;
                                }
                            `}
                          </style>
                      </div>
                  ),
                  brand: (
                      <AutoComplete
                          options={v.brands.map((br) => {
                              return {
                                  value: br.brandName,
                              };
                          })}
                          showSearch
                          allowClear
                          showArrow
                          className="w-full rounded-4"
                          placeholder="Select Brand"
                          onSelect={(value: any): void => {
                              const brand = v.brands.find((br) => br.brandName === value);
                              setVaccine(v.vaccineId, { brand });

                              finalSelectedVaccines.forEach((s) => {
                                  const curr = brand?.diseases.includes(s.diseaseId);

                                  if (curr) {
                                      setVaccine(s.vaccineId, { brand });
                                  }
                              });
                          }}
                          onChange={(value: any) => {
                              setVaccine(v.vaccineId, {
                                  brand: {
                                      brandId: generateLocalId(),
                                      brandName: value,
                                      diseases: [],
                                  },
                              });
                          }}
                          value={
                              currStatus?.brand?.brandId && currStatus?.brand?.brandName
                                  ? {
                                        id: currStatus?.brand?.brandId,
                                        value: currStatus?.brand?.brandName,
                                    }
                                  : undefined
                          }
                          filterOption={(inputValue, option) =>
                              option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                          }
                      />
                  ),
                  batchNo: (
                      <div className={`flex copy-batch-${idx} flex-col`}>
                          <Input
                              onChange={(e) => {
                                  setVaccine(v.vaccineId, { batchNumber: e.target.value });
                              }}
                              className="rounded-4"
                              placeholder="Batch number"
                              defaultValue={currStatus ? currStatus.batchNumber : undefined}
                              value={currStatus?.batchNumber}
                          />
                          <AntTooltip placement="bottom" content="Copy to all">
                              <div
                                  className={`rounded-full cursor-pointer copy-batch-child-element-${idx} absolute p-2 right-12 bottom-12 bg-darwin-neutral_new-800`}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      const currbatchNo = currStatus?.batchNumber;

                                      finalSelectedVaccines.forEach((vac) => {
                                          const currVac = vaccineStatus.find(
                                              (v) => v.id === vac.vaccineId,
                                          );

                                          if (currVac?.status === currStatus?.status) {
                                              setVaccine(vac.vaccineId, {
                                                  batchNumber: currbatchNo,
                                              });
                                          }
                                      });
                                  }}
                              >
                                  <svg
                                      className="copy fill-white m-2 w-8 h-8"
                                      role="img"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 512 512"
                                  >
                                      <path d="M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"></path>
                                  </svg>
                              </div>
                          </AntTooltip>
                          <style>
                              {`
                                .copy-batch-child-element-${idx} {
                                    display: none;
                                }

                                .copy-batch-${idx}:hover .copy-batch-child-element-${idx} {
                                    display: flex;
                                }
                            `}
                          </style>
                      </div>
                  ),
                  notes: (
                      <Input.TextArea
                          onChange={(e) => {
                              setVaccine(v.vaccineId, { notes: e.target.value });
                          }}
                          rows={1}
                          className="rounded-4"
                          placeholder="Notes..."
                          defaultValue={currStatus ? currStatus.notes : undefined}
                          value={currStatus?.notes}
                      />
                  ),
                  delete: (
                      <AntTooltip content="Reset">
                          <span
                              role="img"
                              aria-label="delete"
                              className="anticon cursor-pointer anticon-delete"
                              style={{ color: 'rgb(97, 106, 143)' }}
                              onClick={() => {
                                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                  // @ts-ignore
                                  setVaccineStatus((prev) => {
                                      const currvaccStatus = currStatus ?? {};

                                      const currInitStatus = {
                                          ...currvaccStatus,
                                          status: isBlockStatus ? currStatus?.status : undefined,
                                          brand: undefined,
                                          notes: undefined,
                                          batchNumber: undefined,
                                          date: undefined,
                                      };

                                      return [
                                          ...prev.filter((p) => p.id !== v.vaccineId),
                                          { ...(currInitStatus ?? {}) },
                                      ];
                                  });
                              }}
                          >
                              {resetIcon('w-16 h-16')}
                          </span>
                      </AntTooltip>
                  ),
              };
          })
        : [];

    const administerVaccine = () => {
        // if (!validate().success) return;

        track('VACCINATION_SAVED');

        try {
            const res: IVaccineStatus[] = [];

            if (vaccineData) {
                const givenVacs = vaccineStatus.filter(
                    (v) => v.status === VACCINATION_STATUS.GIVEN,
                );

                for (let i = 0; i < givenVacs.length; i++) {
                    const curr = givenVacs[i];
                    const currVacc = finalSelectedVaccines?.find((v) => v.vaccineId === curr.id);
                    const diseases = curr.brand?.diseases ?? [];

                    for (let j = 0; j < diseases?.length; j++) {
                        const id = diseases[j];

                        if (currVacc && currVacc.dateRange.ageGroupName && vaccineData[id]) {
                            const vaccData =
                                vaccineData?.[id]?.vaccineSchedule?.[
                                    currVacc.dateRange.ageGroupName
                                ];

                            const currV =
                                id === curr.diseaseId
                                    ? vaccData.find((v) => v.vaccineId === curr.id)
                                    : vaccData?.[0];

                            const info = currV ? [currV] : undefined;

                            if (info) {
                                for (let k = 0; k < info.length; k++) {
                                    const currDose = info[k];
                                    const currDoseId = currDose.vaccineId;

                                    const isPresent =
                                        res.find((v) => v.id === currDoseId) ||
                                        vaccineStatus.find((v) => v.id === currDoseId);
                                    const defaultdate = getDefaultDate(
                                        administeredVaccines,
                                        curr.date,
                                        curr.id,
                                    );

                                    if (currDoseId && !isPresent) {
                                        res.push({
                                            id: currDoseId,
                                            brand: curr.brand,
                                            status: VACCINATION_STATUS.GIVEN,
                                            date:
                                                curr.date ??
                                                (defaultdate
                                                    ? defaultdate.toISOString()
                                                    : today.toISOString()),
                                            diseaseId: id,
                                            doseNo: currDose?.doseNo,
                                            ageGroup: currDose?.dateRange?.ageGroupName,
                                            name: currDose?.vaccineName,
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }

            const finalVaccinationStatus = vaccineStatus;

            const newAdministeredVaccs =
                res.length !== 0 ? [...finalVaccinationStatus, ...res] : finalVaccinationStatus;

            const newIds = newAdministeredVaccs.map((v) => v.id);

            const restVaccines = administeredVaccines.filter((v) => !newIds.includes(v.id));

            const finalValue =
                administeredVaccines.length !== 0
                    ? [...restVaccines, ...newAdministeredVaccs]
                    : newAdministeredVaccs;

            const ids = newAdministeredVaccs?.map((v) => v.id);

            const restVaccs = px?.administeredVaccines
                ? px?.administeredVaccines.filter((v) => !ids?.includes(v.id))
                : [];
            const allCurrentVaccines = [...restVaccs, ...(newAdministeredVaccs ?? [])];
            const withDate = allCurrentVaccines?.filter((v) => v.date);
            const dueVaccines = withDate.filter(
                (v) => v.date && v.status === VACCINATION_STATUS.DUE,
            );

            if (withDate?.length) {
                const leastDueDate =
                    withDate?.length === 1
                        ? withDate.find((v) => v.date && v.status === VACCINATION_STATUS.DUE)
                        : dueVaccines.length
                        ? dueVaccines?.reduce((a, b) => {
                              return new Date(a.date!) > new Date(b.date!) ? b : a;
                          })
                        : undefined;

                if (leastDueDate) {
                    onDueFollowupSet?.(leastDueDate);

                    notification.success({
                        message: `Vaccination Reminder Set`,
                        duration: 3,
                    });
                }
            }
            onChange?.(newAdministeredVaccs, finalValue);
            setAdministedVaccines(finalValue);
            setSelectedVaccines([]);
            clearCheckedAgeGroups();
            closeModal();
        } catch (error) {
            track('VACCINATION_SAVED_ERROR');
            console.error(error);
        }
    };

    return (
        <Modal
            closeIcon={() => null}
            closable={false}
            destroyOnClose
            visible={isVisible}
            centered
            footer={
                <div className="flex py-8 items-center w-full justify-between">
                    <div
                        onClick={closeModal}
                        className="px-16 py-8 btn-small cursor-pointer rounded-8 bg-white border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 text-14 font-700"
                    >
                        Close
                    </div>
                    <div
                        onClick={administerVaccine}
                        className="px-16 py-8 btn-small cursor-pointer rounded-8 bg-darwin-accent-bright-blue-800 text-white text-14 font-700"
                    >
                        Done
                    </div>
                </div>
            }
            bodyStyle={{
                padding: 0,
                height: 476,
                borderRadius: 4,
                overflowY: 'hidden',
                maxHeight: 'calc(100vh - 200px)',
            }}
            onCancel={closeModal}
            width="85%"
        >
            <div className="flex flex-col" style={{ maxHeight: 'calc(100vh - 200px)' }}>
                <div className="p-16 border-b border-darwin-neutral_new-200 py-12 flex items-center justify-between">
                    <p className="text-20">{title ?? 'Update vaccines'}</p>
                    <span onClick={closeModal} className="cursor-pointer">
                        {crossIcon('w-14 h-14')}
                    </span>
                </div>
                <div className="px-12 flex flex-col w-full py-16 max-h-420 overflow-auto">
                    {finalSelectedVaccines && (
                        <Table
                            dataSource={data}
                            pagination={false}
                            columns={column}
                            sticky={true}
                            scroll={{ x: 740 }}
                            bordered={true}
                            className="overflow-auto border overflow-auto border-darwin-neutral_new-50 hide-scrollbar"
                        />
                    )}

                    <style>
                        {`
                          .ant-table-thead {
                            .ant-table-cell {
                                background: #F4F4F4;
                            }
                          }
                        `}
                    </style>
                </div>
            </div>
        </Modal>
    );
};

export default VaccineSelectionModal;
